<div id="modal-select-organization" class="modal-select-organization" [@fadeInOut]="state">
  <div class="modal-layer-create-room"></div>
  <div class="modal-content-create-room" [ngClass]="{'modal-content-create-room-center': showOnCenter}">
    <div class="modal-header">
      <h2>{{ shouldTranslate ? (title | translate) : title }}</h2>
      <button type="button" class="close-modal-create-room" (click)="closeModal()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" (ngSubmit)="select()">
        <div class="row-field-create-room">
          <select required formControlName="value">
            <option value="">--{{ 'common.select-option' | translate }}--</option>
            @for (option of options; track option.key) {
              <option [value]="option.key" [disabled]="currentOption && option.key == currentOption">
                {{ shouldTranslate ? (option.value | translate) : option.value }}
                {{ currentOption && option.key == currentOption ? ' (' +  ('common.current' | translate)  +')': '' }}
              </option>
            }
          </select>
        </div>

        <div class="modal-footer">
          <button type="button" class="modal-button-cancel-confirmation" (click)="closeModal()">
            {{ 'common.cancel' | translate }}
          </button>

          <button type="submit" class="modal-button-save" [disabled]="loading">
            {{ (loading ? 'common.loading' : 'common.continue') | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
